import React, {
  useContext, useEffect, useState,
} from 'react';
import { useIntl } from 'react-intl';
import AsyncSelect from 'react-select/async';
import { useForm } from 'react-hook-form';
import InputsAboutPerson from './components/AboutPerson';
import PopUpWrapper from './components/PopUpWrapper';
import { appStore } from '../../state/app';
import CustomBtn from '../../generic/CustomBtn';
import { requestApi } from '../../utils/api-request';

const AssignFieldAgent = ({ showPopUp, setShowPopUp, simpleZoneInfo }) => {
  const { handleSubmit, register, watch } = useForm();
  const { update } = useContext(appStore);
  const [disableSelect, setDisableSelect] = useState(false);
  const [disabledInput, setDisabledInput] = useState(false);
  const [resCreateFieldAgent, setResCreateFieldAgent] = useState('');
  const translate = useIntl();

  const defaultSelectValue = {
    value: '',
    label: '',
  };
  const [asyncSelect, setAsyncSelect] = useState(defaultSelectValue);
  const inputName = watch('name');
  const inputEmail = watch('email');

  const createAndAssignFieldAgent = async (data) => {
    let fieldAgentCreateResponse = {};
    if (inputName || inputEmail) {
      fieldAgentCreateResponse = await requestApi('POST', '/api/dashboard/field-agent', { ...data });
    }
    if (!fieldAgentCreateResponse.message) {
      if ((fieldAgentCreateResponse && fieldAgentCreateResponse.id) || asyncSelect.value) {
        await requestApi('POST', '/api/dashboard/sample-zone/list', {
          field_agent_id: fieldAgentCreateResponse.id || asyncSelect.value, ...simpleZoneInfo,
        });
      }
      const requestFieldAgentsList = await requestApi('GET', '/api/dashboard/field-agent/list');
      update('app.allFa', requestFieldAgentsList);
      setShowPopUp(!showPopUp);
    } else {
      setResCreateFieldAgent(fieldAgentCreateResponse.message);
    }
  };

  useEffect(() => {
    if (inputName || inputEmail) {
      return setDisableSelect(true);
    }

    if (asyncSelect.value) {
      return setDisabledInput(true);
    }

    setDisableSelect(false);
    setDisabledInput(false);
  }, [inputName, inputEmail, asyncSelect.value]);

  const customStyles = {
    control: (styles) => ({
      ...styles,
      height: 60,
      fontFamily: 'inherit',
      color: '#5b6075',
      '&:focus-within': {
        borderColor: '#329D9C',
        boxShadow: '0 0 0 1px #329D9C',
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#5b6075',
      fontSize: 16,
      fontWeight: 400,
    }),
  };
  const filterNames = (inputValue, data) => data.filter((i) => i.label.toLowerCase().includes(inputValue.toLowerCase()));
  const promiseOptions = (inputValue) => {
    const response = requestApi('GET', '/api/dashboard/field-agent/list').then((data) => data.map((index) => ({
      value: index.id,
      label: index.name,
    })));
    return response.then((data) => filterNames(inputValue, data));
  };

  return (
    <PopUpWrapper showPopUp={showPopUp} setShowPopUp={setShowPopUp} widthParam="width-654">
      <h3 className="assign__caption">
        {translate.formatMessage({ id: 'popUp.fieldAgents.assign' })}
      </h3>
      <form onSubmit={handleSubmit(createAndAssignFieldAgent)}>
        <div className="select-wrapper">
          <span className="select-wrapper__label">
            {translate.formatMessage({ id: 'popUp.fieldAgents.select' })}
          </span>
          <AsyncSelect
            cacheOptions
            defaultOptions
            isClearable
            loadOptions={promiseOptions}
            placeholder={translate.formatMessage({ id: 'popUp.fieldAgents.select-placeholder' })}
            styles={customStyles}
            isDisabled={disableSelect}
            onChange={(val) => {
              if (val) {
                return setAsyncSelect(val);
              }
              return setAsyncSelect(defaultSelectValue);
            }}
          />
        </div>
        <div className="assign__separator">
          {translate.formatMessage({ id: 'popUp.fieldAgents.separator' })}
        </div>
        <InputsAboutPerson
          register={register}
          disabledInput={disabledInput}
          resCreateFieldAgent={resCreateFieldAgent}
        />
        <CustomBtn
          label={translate.formatMessage({ id: 'popUp.fieldAgents.assign' })}
          customClass="assign__btn-accept"
          type="submit"
          handleClick={() => {}}
        />
      </form>
    </PopUpWrapper>
  );
};

export default AssignFieldAgent;
